import { i18n } from '@appbase/util'
import { DirectiveOptions } from 'vue'
import SynapEditorWrapper from './SynapEditorWrapper'

declare var synapEditorConfig: editor.synap.SynapEditorConfig
declare var SynapEditor: any

var callbacks: { [key: string]: Function } = {}
var loadedEditorIds: string[] = []

/** SynapEditor Editor 초기화된 상태 */
export function loaded(id: string) {
    return loadedEditorIds.includes(id)
}

export function unload(id: string) {
    const idx = loadedEditorIds.indexOf(id)
    if (idx >= 0) {
        loadedEditorIds = [
            ...loadedEditorIds.slice(0, idx),
            ...loadedEditorIds.slice(idx + 1),
        ]
    }
    SynapEditor.destroy(id)
}

const editorDirective: DirectiveOptions = {
    inserted: (el, binding, vnode) => {
        const ctx = vnode.context as SynapEditorWrapper
        const { editorId, initialValue, synapopts: options, mode, onedit } = ctx
        const { rawName, value } = binding as any
        
        Object.assign(synapEditorConfig, options);

        if (rawName === 'v-synap:loaded') {
            callbacks[editorId] = value
        }   
           
        // 읽기 모드인 경우 툴바 기능 제거
        if (mode === 'view') {
            synapEditorConfig['editor.toolbar'] = []
        } else {
            synapEditorConfig['editor.mode.iframe'] = {
                enable: true,
                "script.urls": ['/cm/gres/libs/synap-editor/SynapEditor/iframeMode/SEPolyfill.min.js'],
                "style.urls": ['/cm/gres/libs/synap-editor/SynapEditor/iframeMode/contentsEditStyle.css']
            },
            synapEditorConfig['editor.balloon'] = {
                'tableCell': ['formulaInput', '-', 'fill', 'selectBorder', 'borderColor', 'lineThickness', 'lineStyle', 'fitTableWidth', '-', 'insertRowBefore', 'insertRowAfter', 'insertColBefore', 'insertColAfter', 'deleteRow', 'deleteCol', 'deleteTable', '-', 'contentsAlign', 'verticalAlign',  'cellSize', 'mergeCell', 'splitCell', 'cellProperties', 'tableProperties']
            }
        }

        synapEditorConfig['editor.lang'] =
            i18n.locale === 'cn' ? 'zh' : i18n.locale

        console.log('synapEditorConfig', synapEditorConfig)

        const eventListeners = {
            initialized: function (e: any) {
                console.log('synap-directive', 'initialized', e)
                var editor = e.editor
               
                loadedEditorIds.push(editor.ID as string)
                callbacks[editorId](editor)

                if(onedit) {
                    editor.setEventListener('afterEdit', (event: any) => {
                        var content = editor.getPublishingHtml();
                        onedit(content, editor);
                    })    
                }                        
            },
            initializedSync: function (e: any) {
                var editor = e.editor
            },
        }
      
        var editor = new SynapEditor(
            editorId,
            synapEditorConfig,
            initialValue,
            eventListeners
        );
        
        // 읽기모드인 경우 preview 모드로 변경
        if (mode === 'view') {
            editor.setMode('preview');
        }
    },
}
export default editorDirective
